import { getMonthlyPayment } from '../../ui-kit/Calculator/getMonthlyPayment.js';
import { getLimitRangeByKeys } from '../../ui-kit/Calculator/rangeHelpers.js';
import { DEFAULT_CREDIT_CALCULATOR_PARAMS } from './defaultCreditCalculatorParams.js';
import { getCreditCalculatorLimitParams } from './getCreditCalculatorLimitParams.js';
import { getCreditCalculatorRateParams } from './getCreditCalculatorRateParams.js';
export const getCreditCalculatorParams = (userInputParams, calcSource, paramsViewSettings) => {
    const { moneyValue, monthsValue } = userInputParams;
    const rateRows = calcSource?.rateRows || [DEFAULT_CREDIT_CALCULATOR_PARAMS];
    const limitRows = calcSource?.limitRows || [];
    const creditCalculatorSourceBookLimitParams = getCreditCalculatorLimitParams({
        limitRows,
        userInputParams,
        paramsViewSettings,
    });
    const { minSum, maxSum } = getLimitRangeByKeys(['minSum', 'maxSum'], creditCalculatorSourceBookLimitParams, rateRows);
    const { minMonths, maxMonths } = getLimitRangeByKeys(['minMonths', 'maxMonths'], creditCalculatorSourceBookLimitParams, rateRows);
    const creditCalculatorRateParams = getCreditCalculatorRateParams({
        rateRows,
        userInputParams,
        paramsViewSettings,
        moneyValue,
        monthsValue,
    });
    const { rate } = creditCalculatorRateParams;
    const monthlyPayment = getMonthlyPayment(rate, userInputParams);
    return {
        ...creditCalculatorRateParams,
        ...userInputParams,
        minSum,
        maxSum,
        minMonths,
        maxMonths,
        moneyValue,
        monthsValue,
        monthlyPayment,
    };
};
//# sourceMappingURL=getCreditCalculatorParams.js.map